import {
  Alert,
  HStack,
  Stack,
  AlertTitle,
  AlertDescription,
  useDisclosure,
  Button,
  useColorModeValue,
  LightMode,
  Icon,
} from '@ecoinvent/ui';
import { IoLeaf } from 'react-icons/io5';
import { useAuth } from 'react-oidc-context';

const SignInUpsell = () => {
  const { isOpen: isVisible } = useDisclosure({ defaultIsOpen: true });
  const auth = useAuth();
  const gradientColorLeft = useColorModeValue('#D9DEF8', '#324692');
  const gradientColorRight = useColorModeValue('#D8F5E6', '#045D3B');
  const buttonColorVariant = useColorModeValue('solid', 'subtle');

  return (
    isVisible && (
      <Alert
        variant="subtle"
        status="success"
        borderRadius={'md'}
        bgGradient={`linear(to-r, ${gradientColorLeft}, ${gradientColorRight})`}
      >
        <HStack w="100%" justifyContent="space-between" flexDirection={{ base: 'column', md: 'row' }}>
          <HStack spacing={4}>
            <Icon as={IoLeaf} />
            <Stack spacing={0}>
              <AlertTitle>See Impact Scores in search results</AlertTitle>
              <AlertDescription>Sign in or create an account to access full datasets, impact scores and more.</AlertDescription>
            </Stack>
          </HStack>
          <LightMode>
            <Button
              width={{ base: '100%', md: 'auto' }}
              variant={buttonColorVariant}
              onClick={() => {
                auth.signinRedirect({ redirect_uri: window.location.href });
              }}
            >
              Sign In
            </Button>
          </LightMode>
        </HStack>
      </Alert>
    )
  );
};

export default SignInUpsell;
